<div class="is-fixed-bottom">
  <div class="container has-text-centered">
    <div class="columns">
      <div class="column">
        <p class="links">
          <a class="has-text-dark" on:click="{() => push('/impressum')}">
            <span>Impressum</span>
          </a>
          <a class="has-text-dark" on:click="{() => push('/datenschutz')}">
            <span>Datenschutzerklärung</span>
          </a>
          <a class="has-text-dark" on:click="{() => push('/agb')}">
            <span>AGB</span>
          </a>
        </p>
      </div>
    </div>
  </div>
</div>

<script>
import { push } from "svelte-spa-router";

export let params = {};
export let backPath;
</script>

<style type="text/scss">
@import "./scss/colors";
.is-clickable {
  cursor: pointer;
}

.is-fixed-bottom {
  background: #fff;
  z-index: 5;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px;

  .links a {
    position: relative;
    padding: 5px;
  }

  .links a:not(:last-child) {
    padding-right: 15px;
    &:hover {
      color: #999;
    }
  }
  .links a:not(:last-child)::after {
    content: "•";
    position: absolute;
    top: 0;
    right: 0;
  }
}
</style>
